module.exports = __webpack_public_path__ + "static/media/membership2025-adult-new.0de15f89.jpg";